<div class="col text-center">
    <div class="row justify-content-center">
        <div class="dialog-title-box">
            <div class="col">
                <div class="row">
                    <div class="col pt-3">
                        <i [ngClass]="data.icon" class=" icon" id="questionIcon"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col pb-3 pt-3">
                        <span id="confirmation" class="title pb-1 mt-3 mb-3">
                            {{data.title}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<mat-dialog-content class="mat-typography mat-dialog-content">
<div class="col p-0">
    <h2 class="col maincontent pt-4 mb-1 text-center" id="confirmation">
        {{data.message}}
    </h2>
   
    <h2 class="col subcontent mb-2 text-center" id=""></h2>
</div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
<div class="col text-center pb-3">
    <div class="row">
        <div class="pt-3 justify-content-center">
            <button mat-dialog-close="" tabindex="1" type="button" id="" (click)="closeAllDialogs()"
                class="btn btn-primary  center-block w-70" style="margin-right: 8px;">
                Close
            </button>
            <button (click)="redirectGateway()" tabindex="1" type="button" id=""
                class="btn btn-primary ml-2 w-70">
                Activate
            </button>
        </div>
    </div>
</div>
</mat-dialog-actions>
